import React from 'react';

interface ILeverantorAttestWrapperContext {
  routineIsReadOnly: boolean;
}

export const LeverantorAttestWrapperContext =
  React.createContext<ILeverantorAttestWrapperContext>({
    routineIsReadOnly: false,
  });
